<template>
  <div>
  <table class="w-full">
    <thead class="bg-blue-lightest">
      <tr>
        <th class="p-2 text-sm font-semibold text-center uppercase text-blue-dark w-16"></th>
        <th class="p-2 text-sm font-semibold uppercase text-blue-dark">{{ $t("task") }}</th>
        <th class="p-2 text-sm font-semibold uppercase text-blue-dark">{{  }}</th>
        <th class="p-2 text-sm font-semibold text-center uppercase text-blue-dark w-28">{{ $t("status") }}</th>
        <th class="p-2 text-sm font-semibold uppercase text-blue-dark w-10" ></th>
      </tr>
    </thead>
    <tbody>
      <template v-for="row in listTasks">

        <tr class="hover:bg-grey-lightest border px-2 py-1" :key="row.id" >
          <!-- Icono Detalles / Historia -->
          <td class="align-middle" >
            <div class="flex items-center justify-center gap-1">
              <!-- actions -->
              <!-- icono incidencia -->
              <div v-if="company && company.configs && company.configs.subtasks" class="pt-2">
                <div v-if="row.issue_status && getIssueIcon(row) != null" class="flex text-center align-middle cursor-pointer" >
                  <b-tooltip class="text-center"
                    :label="$t('issues')" position="is-right">
                    <b-icon v-if="getIssueIcon(row).icon != 'hand'"
                    :icon="getIssueIcon(row).icon" pack="fas" size="is-small" :class="getIssueIcon(row).color">
                    </b-icon>
                    <!-- si es hand usamos la imagen -->
                    <img v-else :src="asset('public/westop-tke.png')" alt="Expanded Image" width="50" class="p-2" />

                  </b-tooltip>
                </div>
              </div>
              <!-- si no tiene children mostramos icono de detalle hisotial -->
              <div v-if="row.children_count == 0" class="pt-2">
                <div v-if="row.lines && row.lines.length" 
                  class="flex text-center align-middle cursor-pointer" @click="displayHistory(row.id)">
                  <b-tooltip
                    :label="$t('display_history',[
                      project.can_progress == 0
                        ? row.lines.filter(line => line.status !== 10).length
                        : row.lines.length
                    ])"
                    position="is-right"
                  >
                    <div class="flex flex-col items-center">
                      <div class="flex items-center">
                        <span class="mr-1 text-xs font-semibold text-blue">{{ 
                        project.can_progress == 0
                            ? row.lines.filter(line => line.status !== 10).length
                            : row.lines.length }}
                        </span>
                        <b-icon icon="history" pack="fas" size="is-small" class="mr-1 text-blue"/>
                      </div>
                      <b-icon :icon="isHistoryOpen(row) ? 'chevron-up' : 'chevron-down'" pack="fas" size="is-small" class="text-blue"/>
                      </div>
                  </b-tooltip>
                </div>
              </div>
              <div v-else class="text-xs text-gray-500 italic pt-2">
                <!-- icono mostrar subtareas -->
                <div class="flex text-center align-middle cursor-pointer" @click="displaySubTasks(row)">
                  <b-tooltip :label="$t('display_subtasks', [row.children_count])" position="is-right">
                    <div class="flex flex-col items-center">
                      <div class="flex items-center">
                        <span class="mr-1 text-xs font-semibold text-blue">
                          {{ row.children_count }}
                        </span>
                        <b-icon icon="list" pack="fas" size="is-small" class="mr-1 text-blue" />
                      </div>
                      <b-icon :icon="isTaskExpanded(row) ? 'chevron-up' : 'chevron-down'"
                        pack="fas" size="is-small" class="text-blue mt-1"/>
                    </div>
                  </b-tooltip>
                </div>
              </div>
            </div>
          </td>
          <!-- user -->
          <!-- <td class="justify-start w-auto h-full p-4 align-middle">
            <div class="flex flex-row items-center justify-start w-auto h-full">
              <div class="w-8 h-8 rounded-full">
                <img class="w-8 h-8 rounded-full" :src="row.user.avatar"/>
              </div>
              <div class="flex flex-col ml-2">
                <div class="text-xs">{{ row.user.fullname}}</div>
                <div class="text-xs text-grey-dark">{{ row.user.area}}</div>
              </div>
            </div>
          </td> -->

          <!-- Titulo / Peso -->
          <td class="p-2" v-if="!row.completed">
            <b-tooltip position="is-bottom" multilined>
              <div>
              <div class="text-xs font-semibold">{{ row.name }}</div>
              <div v-if="deph == 0"
              class="text-xs text-blue"><span class="font-semibold">{{ $t('resource_weight_msg', [row.weight]) }}</span></div>
              <div class="text-xs text-gray-500 italic">
                {{ $t('created_at') }} : {{ dateToText(row.created_at) }}
              </div>
              <div v-if="isTaskEditing" class="flex flex-col">
                <b-field label="Nombre" label-position="inside">
                  <b-input
                    v-model="row.name"
                    type="text"
                    class="w-full"
                    placeholder="Nombre de la tarea"
                    :class="{'is-danger': row.name == ''}"
                    @input="onEditTask(row, 'name')"
                  ></b-input>
                </b-field>
              </div>
              </div>
              <template v-slot:content>
                <div>                                  
                  <div class="text-xs font-semibold">
                      <b>{{ row.name }}</b>
                  </div>
                  <div class="text-xs text-dark whitespace-pre-line">
                    <i>{{ row.description }} </i>
                  </div>
                </div>
              </template>
            </b-tooltip>
          </td>
          <td class="p-2" v-else>
            <b-tooltip position="is-bottom" multilined>
              <div>
              <div class="flex flex-row items-center">
                <div class="w-2 h-2 mr-1 rounded-full bg-green"></div>
                <div class="text-xs font-semibold">{{ row.name }}</div>
              </div>
              <div v-if="deph == 0"
               class="text-xs text-blue"><span class="font-semibold">{{ $t('resource_weight_msg', [row.weight]) }}</span></div>
              <div class="text-xs text-gray-500 italic">
                {{ $t('created_at') }} : {{ dateToText(row.created_at) }}
              </div>
              <!-- if isTaskEditting -->
              <div v-if="isTaskEditing" class="flex flex-col">
                <b-field label="Nombre" label-position="inside">
                  <b-input
                    v-model="row.name"
                    type="text"
                    class="w-full"
                    placeholder="Nombre de la tarea"
                    :class="{'is-danger': row.name == ''}"
                    @input="onEditTask(row, 'name')"
                  ></b-input>
                </b-field>
              </div>
              </div>
              <template v-slot:content>
                <div>                                  
                  <div class="text-xs font-semibold">
                      <b>{{ row.name }}</b>
                  </div>
                  <div class="text-xs text-dark whitespace-pre-line">
                    <i>{{ row.description }} </i>
                  </div>
                </div>
              </template>
            </b-tooltip>

          </td>

          <!-- Fechas / Plazo-->
          <td class="p-2">
            <!-- if completed show date completed -->
            <div class="flex flex-col gap-1">
              <div>
                <div :class="row.executed_quantity == 100 ? 'text-xs' : 'text-xs text-transparent select-none'">
                  {{ $t("activity_status_done") }} {{ $t('inspected') }}: {{ row.inspected_completed_date }}
                </div>
              </div>
              <div v-if="row.actual_progress == 100 && project.can_progress">
                <div class="text-xs">
                  {{ $t("activity_status_done") }} {{ $t('actual') }}: {{  row.actual_completed_date }} 
                </div>
              </div>
            </div>

            <!-- ponderation -->
            <div v-if="isTaskEditing" class="flex flex-col">
              <b-field label="Peso" label-position="inside">
                <b-input
                  v-model="row.weight"
                  type="number"
                  min="0"
                  step="0.01"
                  :disabled="!canEditAssignments()"
                  @input="onEditTask(row, 'weight')"
                  class="w-full"
                  placeholder="Peso de la tarea"
                  :class="{'is-danger': row.weight == ''}"
                ></b-input>
              </b-field>
            </div>
          </td>

          <!-- progress bar -->
          <td class="p-1">
            <div class="flex justify-start w-auto h-full align-middle" 
              v-if="row.completed && !project.can_progress">
              <div class="px-2 py-1 text-xs text-white rounded-full bg-green">{{ $t('completed')}}</div>
            </div>
            <div v-else class="h-full align-middle">
              <!-- progress-bar -->
                <b-tooltip class="w-full" :label="$t('progress_inspected_label')" position="is-top">
                <span>
                  <progress-bar
                    :step="parseFloat(row.executed_quantity) || 0"
                    color="blue-light"
                    class="w-full"
                  />
                </span>
              </b-tooltip>
              <!-- progress-bar-real -->
                <b-tooltip v-if="project.can_progress"
                class="w-full" :label="$t('actual_progress')" position="is-top">
                <span>
                  <progress-bar
                    :step="parseFloat(row.actual_progress) || 0"
                    color="green"
                    class="w-full"
                  />
                </span>
              </b-tooltip>
            </div>
          </td>

          <!-- Opciones -->
          <td class="justify-center w-auto h-full p-4 align-middle">
            <div class="text-center cursor-pointer">
              <b-dropdown aria-role="list" position="is-bottom-left">

                <template #trigger="{ active }">
                    <b-icon :icon="active ? 'ellipsis-h' : 'ellipsis-v'" pack="fas" size="is-small" class="text-blue"></b-icon>
                </template>
                <b-dropdown-item v-if="project.can_admin && isLockAssignmentTask(row) == false"
                  aria-role="listitem" @click="onClickTaskEdit(row)">
                  <span class="text-xs">{{ $t('edit') }}</span>
                </b-dropdown-item>
                <b-dropdown-item 
                aria-role="listitem" @click="onCommentChanged(row)" v-if="project.can_admin && isLockAssignmentTask(row) == false">
                  <span class="text-xs">{{ $t('add_comment_document') }}</span>
                </b-dropdown-item>
                <b-dropdown-item 
                  v-if="(row.children_count && row.children_count > 0)"
                  aria-role="listitem" @click="displayHistory(row.id)">
                  <span class="text-xs">{{ $t('display_history',[
                    project.can_progress == 0
                      ? row.lines && row.lines.filter(line => line.status !== 10).length
                      : row.lines && row.lines.length
                  ]) }}</span>
                </b-dropdown-item>
                <b-dropdown-item 
                  v-if="project.can_certificate && hasPendingValidation(row) && isLockAssignmentTask(row) == false"
                  aria-role="listitem" @click="onClickValidate(row)">
                  <span class="text-xs">{{ $t('validate_progress') }}</span>
                </b-dropdown-item>
                <!-- valida tarea pendiente de validar incidecia -->
                <b-dropdown-item 
                  v-if="project.can_task_resolutor && hasPendingValidationIssue(row)"
                  aria-role="listitem" @click="onClickValidateIssue(row)">
                  <span class="text-xs text-red">{{ $t('validate_issue') }}</span>
                </b-dropdown-item>
                <b-dropdown-item separator v-if="!row.completed"></b-dropdown-item>
                 <!-- create sub task -->
                <b-dropdown-item aria-role="listitem" @click="onCreateTaskSubTask(row)" v-if="canManage && withSubTasks() && isLockAssignmentTask(row) == false">
                  <span class="text-xs text-blue">{{ $t('add_subtask') }}</span>
                </b-dropdown-item>
                <b-dropdown-item aria-role="listitem" @click="onRegisterTask(row)" 
                  v-if="row.children_count == 0 && isLockAssignmentTask(row) == false" 
                  :class="''">
                  <span class="text-xs font-medium" :class="'text-green'">{{ $t('register_inspect') }}</span>
                </b-dropdown-item>
               
                <!-- real -->
                <b-dropdown-item aria-role="listitem" @click="onRegisterTask(row, true)" v-if="row.children_count == 0 && project.can_progress" :class="''">
                  <span class="text-xs font-medium" :class="'text-green'">{{ $t('register_real') }}</span>
                </b-dropdown-item>

                <!-- create issue task -->
                <b-dropdown-item aria-role="listitem" @click="onRegisterTask(row, false, 2)"
                  v-if=" company && company.configs && company.configs.subtasks && isLockAssignmentTask(row) == false"
                >
                  <span class="text-xs text-red">{{ $t('add_issue') }}</span>
                </b-dropdown-item>
                <!-- resolve issue task -->
                <b-dropdown-item aria-role="listitem" @click="onRegisterTask(row, false, 4)" 
                  v-if="isIssueResolver(row)"
                >
                  <span class="text-xs text-red">{{ $t('resolve_issue') }}</span> 
                </b-dropdown-item>
                <!-- create block type -->
                <b-dropdown-item aria-role="listitem" @click="onRegisterTask(row, false, 3)" 
                  v-if="withLockTypeCreator(row) && isLockAssignmentTask(row) == false"
                >
                  <span class="text-xs text-red">{{ $t('add_lock_type') }}</span>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td>

        </tr>

        <tr :key="'detail-' +row.id" class="border px-2 py-1">
            <td colspan="5" :class="{'hidden': !(isHistoryOpen(row) || isTaskExpanded(row))}" 
            class="border px-2 py-1"
            >
              <div class="p-2 " v-if="isHistoryOpen(row)">
                 <table class="w-full">

                  <tr class="bg-indigo-lightest">

                      <td colspan="5" class="p-4">
                              <div class="flex justify-start w-auto h-full align-middle">
                              <b-icon icon="history" pack="fas" size="is-small" class="ml-1 text-blue"></b-icon>
                              <span class="ml-2 text-xs font-semibold text-blue">{{$t('resource_history_header') }}</span>
                              </div>
                          </td>
                          </tr>

                          <tr class="bg-blue-lightest">
                              <th align="center" class="p-2 text-sm font-semibold uppercase text-blue-dark">{{ $t('date') }}</th>
                              <th class="p-2 text-sm font-semibold uppercase text-blue-dark">{{ $t('user') }}</th>
                              <th align="center" class="p-2 text-sm font-semibold uppercase text-blue-dark">{{ $t('action') }}</th>
                              <th class="p-2 text-sm font-semibold uppercase text-blue-dark">{{ $t('observations') }}</th>
                              <th></th>
                          </tr>
                  <tbody>
                      <template v-for="rowHistory in row.lines">

                      <tr :key="rowHistory.id" :class="getClassColorAssignmentLineStatus(rowHistory.status)" 
                      v-if="!(project.can_progress == 0 && rowHistory.status == 10)"
                      >

                          <td align="center" class="justify-start w-auto h-full p-4">
                              <div class="text-xs text-center">
                                <div class="my-1 text-xs font-semibold text-blue-light">
                                  {{dateToText(rowHistory.created_at)}}
                                </div>
                              </div>
                          </td>

                          <td class="p-2">

                              <div class="flex flex-row items-center justify-start w-auto h-full">
                              <div class="w-8 h-8 rounded-full">
                                  <img class="w-8 h-8 rounded-full" :src="rowHistory.user.avatar"/>
                              </div>
                              <div class="flex flex-col ml-2">
                                  <div class="text-xs">{{ rowHistory.user.fullname}}</div>
                                  <div class="text-xs text-grey-dark">{{ rowHistory.user.area}}</div>
                              </div>
                              </div>

                          </td>

                          <td align="center" class="h-full p-4">
                              <div v-if="rowHistory.status == 11">
                                <div class="text-xs">
                                  {{ $t('comment_single') }}
                                </div>
                              </div>
                              
                              <div v-else-if="rowHistory.status == 1">
                                <div class="text-xs">
                                  {{ $t('pending_validation_quantity') }}: {{ rowHistory.executed_quantity}} %
                                </div>
                              </div>
                              <div v-else-if="rowHistory.status == 2">
                                <div class="text-xs">
                                  {{ $t('rejected') }}: {{ rowHistory.executed_quantity}} %
                                </div>
                              </div>
                              <div v-else-if="rowHistory.status == 3">
                                <div class="text-xs">
                                  {{ $t('action') }} {{ $t('valid') }}: {{ rowHistory.executed_quantity}} %
                                </div>
                              </div>
                              <div v-else-if="rowHistory.status == 4">
                                <div class="text-xs">
                                  {{ $t('action') }}{{ $t('rejected') }}: {{ rowHistory.executed_quantity}} % 
                                </div>
                              </div>
                              <div v-else-if="rowHistory.status == 20">
                                <div class="text-xs text-red">
                                  {{ $t('issue_created') }} 
                                </div>
                              </div>
                              <div v-else-if="rowHistory.status == 21">
                                <div class="text-xs text-yellow">
                                  {{ $t('task_issue_resolved') }} 
                                </div>
                              </div>
                              <div v-else-if="rowHistory.status == 22">
                                <div class="text-xs text-orange">
                                  {{ $t('task_issue_without_blocking') }}
                                </div>
                              </div>
                              <div v-else-if="rowHistory.status == 23">
                                <div class="text-xs text-red">
                                  {{ $t('task_issue_with_task_blocking') }}
                                </div>
                              </div>
                              <div v-else-if="rowHistory.status == 24">
                                <div class="text-xs text-orange">
                                  {{ $t('task_issue_with_activity_blocking') }}
                                </div>
                              </div>
                              <div v-else-if="rowHistory.status == 25">
                                <div class="text-xs text-red">
                                  {{ $t('task_issue_with_project_blocking') }}
                                </div>
                              </div>
                              <div v-else-if="rowHistory.status == 26">
                                <div class="text-xs text-yellow">
                                  {{ $t('task_issue_lock_solved') }}
                                </div>
                              </div>
                              <div v-else-if="rowHistory.status == 27">
                                <div class="text-xs text-green">
                                  {{ $t('task_issue_resolved') }}
                                </div>
                              </div>
                              <div v-else-if="rowHistory.status == 28">
                                <div class="text-xs text-orange">
                                  {{ $t('task_issue_with_parent_activity_blocking') }}
                                </div>
                              </div>
                              <div v-else-if="rowHistory.status == 30">
                                <div class="text-xs text-yellow">
                                  {{ $t('validation_status_pending_validation') }}
                                </div>
                              </div>
                              <div v-else-if="rowHistory.status == 31">
                                <div class="text-xs text-red">
                                  {{ $t('rejected') }}
                                </div>
                              </div>
                              <div v-else-if="rowHistory.status == 32">
                                <div class="text-xs text-green">
                                  {{ $t('accepted') }}
                                </div>
                              </div>
                              
                              <div v-else class="text-xs">{{ $t('execute') }} {{ rowHistory.status == 0 ? $t('inspected') : $t('actual') }}
                                {{ rowHistory.executed_quantity}} % </div>
                              <div class="text-xs">{{ moment(rowHistory.start_date).format('DD/MM/YYYY') }}</div>

                          </td>

                          <td class="w-2/5 p-2">
                              <div class="flex flex-col">
                              <div class="text-xs" v-html="rowHistory.observation"></div>
                              <div class="flex flex-row flex-wrap">

                                <template v-for="rowDocument in rowHistory.documents">
                                  <b-tooltip :label="rowDocument.name" position="is-top" :key="rowDocument.document_id">
                                    <div @click="showPreview(rowDocument)" class="w-12 h-12 m-1 rounded-lg shadow cursor-pointer bg-grey">
                                      <img class="w-12 h-12 rounded-lg" :src="rowDocument.file.thumbnail" onerror="this.src='https://epc-tracker-assets.s3.eu-west-3.amazonaws.com/public/document.jpeg'" />
                                    </div>
                                  </b-tooltip>
                                </template>
                              </div>
                              </div>
                          </td>  
                          <td class="justify-center w-auto h-full p-4 align-middle">
                            <div class="text-center cursor-pointer">
                              <b-dropdown aria-role="list" position="is-bottom-left">

                                <template #trigger="{ active }">
                                    <b-icon :icon="active ? 'ellipsis-h' : 'ellipsis-v'" pack="fas" size="is-small" class="text-blue"></b-icon>
                                </template>
                                <b-dropdown-item
                                  v-if="(project.can_admin || project.can_certificate) && (rowHistory.status == 0 || rowHistory.status == 10)"
                                  aria-role="listitem" @click="onEditLine(rowHistory, row)">
                                  <span class="text-xs">{{ $t('edit') }}</span>
                                </b-dropdown-item>
                                <b-dropdown-item 
                                  v-if="(project.can_admin || project.can_certificate) && rowHistory.status == 1"
                                  aria-role="listitem" @click="onClickValidate(row, rowHistory)">
                                  <span class="text-xs">{{ $t('validate') }}</span>
                                </b-dropdown-item>
                                <b-dropdown-item
                                  v-if="project.can_admin" aria-role="listitem" @click="onDeleteLine(rowHistory, row.id)">
                                  <span class="text-xs red">{{ $t('delete') }}</span>
                                </b-dropdown-item>
                              </b-dropdown>
                            </div>
                          </td>

                      </tr>
                      </template>
                  </tbody>

              </table>
              </div>
              <div class="p-2 " v-if="isTaskExpanded(row)">

                <!-- loading solo en la primera carga del nivel -->
                <div v-if="isChildrenLoading(row)"
                  class="flex justify-center w-full py-4">
                  <b-icon icon="loading" pack="fas" size="is-large" class="text-blue"></b-icon>
                  <span class="ml-2 text-blue">{{ $t('loading') }}...</span>
                </div>
                
                <assignment-task-table v-else-if="row.children && row.children.length"
                  :isTaskEditing="false"
                  :listTasks="row.children"
                  :subactivityId="subactivityId"
                  :canManage="canManage"
                  :canAdd="canAdd"
                  :entityId="entityId"
                  :deph="deph + 1"
                  :locked="isLockAssignmentTask(row)"
                  :expandedTaskIds="expandedTaskIds"
                  :openHistoryTaskIds="openHistoryTaskIds"
                  @update:list-tasks="(value) => row.children = value"
                  @reload="() => reload()"
              />
              </div>
            </td>
        </tr>

      </template>
    </tbody>
  </table>
  
        <!-- Modal para crear tarea -->
    <task-modal
      ref="task_modal"
      entity-type="activity"
      :entity-id="entityId"
      @reload="() => reload()"
    />


    <!-- Modal para Editar tarea -->
    <task-update-modal
      ref="task_update_modal"
      entity-type="activity"
      :isSubTask="deph > 0"
      :entity-id="entityId"
      :canManage="canManage"
      @reload="() => reload()"
    />

    <!-- modal para comentario a tarea  -->
    <assignment-comment-task-modal
      ref="assignment_comment_task_modal"
      entity-type="activity"
      :entity-id="entityId"
      @reload="() => reload()"
      v-if="project.can_admin"
    />

    <!-- Modal para Editar -->
    <assignment-update-modal
      ref="assignment_update_modal"
      entity-type="activity"
      :entity-id="entityId"
      :canManage="canManage"
      @reload="() => reload()"
    />


    <!-- Modal para completar -->
    <assignment-completed-modal
      ref="assignment_completed_modal"
      entity-type="activity"
      :entity-id="entityId"
      @reload="() => reload()"
    />

    <!-- Modal de registro de tareas -->
    <assignment-register-task-modal
      ref="assignment_register_task_modal"
      entity-type="activity"
      :subactivity-id="subactivityId"
      :activity-name="activityName"
      :entity-id="entityId"
      @reload="() => reload()"
    />

    <!-- Modal para editar lineas-->
    <assignment-line-edit-modal
      ref="assignment_line_edit_modal"
      entity-type="activity"
      :entity-id="entityId"
      @reload="() => reload()"
    />  

    <!-- Modal para PREVIEW -->
    <assignment-document-preview
        :entity-id="entityId"
        entity-type="activity"
        ref="previewModal"
        :can-delete="canManage"
        @reload="() => reload()"
    />

    <assignment-validate-quantity-modal
        ref="assignment_validate_quantity_modal"
        entity-type="activity"
        :entity-id="entityId"
        @reload="() => reload()"
      />
    <assignment-validate-issue-task-modal
        ref="assignment_validate_issue_task_modal"
        entity-type="activity"
        :entity-id="entityId"
        @reload="() => reload()"
      />
  </div>
</template>

<script>
import axios from "axios";
import moment from 'moment';
import taskModal from "·/components/task-modal";
import assignmentUpdateModal from "·/components/assignment-update-modal";
import taskUpdateModal from "·/components/task-update-modal";
import assignmentCompletedModal from "·/components/assignment-completed-modal";
import assignmentRegisterTaskModal from "·/components/assignment-register-task-modal";
import assignmentDocumentPreview from "../assignment-document-preview";

import assignmentCommentTaskModal from "·/components/assignment-comment-task-modal";
import assignmentLineEditModal from "·/components/assignment-line-edit-modal";
import AssignmentValidateQuantityModal from '·/components/assignment-validate-quantity-modal';
import assignmentValidateIssueTaskModal from "·/components/assignment-validate-issue-task-modal.vue";
import { mapGetters } from "vuex";
import EventBus from "~/plugins/bus";

const ASSIGNMENT_TASK = 'task';
const ASSIGNMENT_CERTIFIER = 'certifier';


export default {
  name: "assignment-task-table",
  components: {
    taskModal,
    assignmentUpdateModal,
    taskUpdateModal,
    assignmentCompletedModal,
    assignmentRegisterTaskModal,
    assignmentDocumentPreview,
    assignmentCommentTaskModal,
    assignmentLineEditModal,
    AssignmentValidateQuantityModal,
    assignmentValidateIssueTaskModal,
  },

  props: {
    listTasks: { type: Array, required: true },
    canManage: { type: Boolean, required: true },
    canAdd: { type: Boolean, required: false },
    isTaskEditing: { type: Boolean, required: true },
    entityId: { type: Number, required: true },
    subactivityId: { type: Number, required: false, default: null },
    activityName: { type: String, required: false, default: '' },
    deph:{ type: Number,  default: 0 },
    locked:{ type: Boolean, default: false },
    onEditTask: { type: Function, required: false },
    /** Mapa compartido { [assignmentId]: true } de subtareas desplegadas en toda la jerarquía. */
    expandedTaskIds: { type: Object, required: false, default: () => ({}) },
    /** Mapa compartido { [assignmentId]: true } de historiales abiertos. */
    openHistoryTaskIds: { type: Object, required: false, default: () => ({}) },

  },
  data() {
    return {
      isLoadingTask: false,
      childrenLoadingIds: {},
      
      lineStatus: {
        ISSUE: 20,
        ISSUE_SOLVED: 21,
        ISSUE_WITHOUT_LOCK: 22,
        ISSUE_LOCK_TASK: 23,
        ISSUE_LOCK_ACTIVITY: 24,
        ISSUE_LOCK_ACTIVITY_PARENT: 28,
        ISSUE_LOCK_PROJECT: 25,
        ISSUE_LOCK_SOLVED: 26,
        ISSUE_RESOLVED: 27,
        ISSUE_PENDIG: 30
      },
    };
  },
  computed: {
        ...mapGetters({
      locale: "lang/locale",
      user: "auth/user",
      company: 'app/company',
      project: 'app/project',
    }),

  },
  methods: {
    dateToText(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    getClassColorAssignmentLineStatus(status) {
      switch (status) {
        case 0: // inspected progress
          return 'hover:bg-grey-lightest bg-blue-lightest'
        case 10: // actual progress
          return 'hover:bg-grey-lightest bg-green-lightest'
        case 1: // validation pending
          return 'hover:bg-grey-lightest bg-yellow-lightest'
        case 2: // rejected
          return 'hover:bg-grey-lightest bg-red-lightest'
        case 3: // action validation
          return 'hover:bg-grey-lightest bg-blue-lightest'
        case 4: // action validation rejected
          return 'hover:bg-grey-lightest bg-red-lightest'
        case 20: // issue
          return 'hover:bg-grey-lightest bg-red-lightest'
        case 21: // issue solved
          return 'hover:bg-grey-lightest bg-yellow-lightest'
        case 22: // issue without lock
          return 'hover:bg-grey-lightest bg-orange-lightest'
        case 23: // issue lock task
          return 'hover:bg-grey-lightest bg-red-lightest'
        case 24: // issue lock activity
          return 'hover:bg-grey-lightest bg-orange-lightest'
        case 25: // issue lock project
          return 'hover:bg-grey-lightest bg-red-lightest'
        case 26: // issue lock solved
          return 'hover:bg-grey-lightest bg-yellow-lightest'
        case 27: // issue resolved
          return 'hover:bg-grey-lightest bg-green-lightest'
        case 28: // issue activity parent locked
          return 'hover:bg-grey-lightest bg-orange-lightest'
        case 30: // issue pending
          return 'hover:bg-grey-lightest bg-yellow-lightest'
        case 31: //reject issue
          return 'hover:bg-grey-lightest bg-red-lightest'
        case 32: // accept issue
          return 'hover:bg-grey-lightest bg-green-lightest'
        default:
          return 'bg-grey-lightest'
      }
    },
    /**
     * Llamamos al modal de registro de tareas 
    */
    onRegisterTask(assignment, isReal=false, actionType = 1) {
      // dejamos desplegado el historial de la tarea para ver la nueva linea tras el registro
      this.collapseTaskBranch(assignment);
      this.$set(this.openHistoryTaskIds, assignment.id, true);

      this.$refs.assignment_register_task_modal.show(assignment, isReal, actionType);
    },
    isTaskExpanded(row) {
      return !!this.expandedTaskIds[row.id];
    },
    isHistoryOpen(row) {
      return !!this.openHistoryTaskIds[row.id];
    },
    isChildrenLoading(row) {
      return !!this.childrenLoadingIds[row.id];
    },
    collapseTaskBranch(row) {
      if (!row || !this.expandedTaskIds[row.id]) {
        return;
      }
      this.$delete(this.expandedTaskIds, row.id);
      (row.children || []).forEach((child) => this.collapseTaskBranch(child));
    },
    displaySubTasks(row) {
      // si abre subtareas, cierra historial de esa fila
      if (this.openHistoryTaskIds[row.id]) {
        this.$delete(this.openHistoryTaskIds, row.id);
      }
    
      if (this.isTaskExpanded(row)) {
        this.collapseTaskBranch(row);
      } else {
        // Solo un hermano expandido por nivel (mismo comportamiento que selected único).
        this.listTasks.forEach((sibling) => {
          if (sibling.id !== row.id && this.expandedTaskIds[sibling.id]) {
            this.collapseTaskBranch(sibling);
          }
        });

        this.$set(this.expandedTaskIds, row.id, true);

        // ademas cargamos las subtareas si no las tiene cargadas
        if (!row.children || row.children.length === 0) {
          this.$set(this.childrenLoadingIds, row.id, true);
          const args = {
            withLines: 1,
            where_type:	"task",
            parent_assignment_id: row.id,
          }
          
          let url = `/api/v2/assignments/activity/${this.entityId}`;
          axios.get(url , { params: args })
            .then(({ data }) => {
              if (data && data.success) {
                this.$set(row, 'children', data.assignments);
              } else {
                this.$toast.open({
                  message: this.$t("error_loading_generic", [this.$t("tasks")]),
                  type: "is-danger",
                });
                this.$delete(this.expandedTaskIds, row.id);
                }
            })
            .catch(() => {
              this.$toast.open({
                message: this.$t("error_loading_generic", [this.$t("tasks")]),
                type: "is-danger",
              });
              this.$delete(this.expandedTaskIds, row.id);
            })
            .finally(() => {
              this.$delete(this.childrenLoadingIds, row.id);
              this.isLoadingTask = false;
            });
        }
      }
    },

    isLockAssignmentTask( assignment ) {
      if (this.locked) {
        return true;
      } else {
        return assignment.lines ? assignment.lines.some(line => line.status == this.lineStatus.ISSUE_LOCK_TASK): false;
      }
    },

    isIssueResolver(assignment) {
      return assignment.lines ? assignment.lines.some(line => line.status == this.lineStatus.ISSUE): false
    },

    getIssueIcon(assignment) {
      const lineStatus = this.lineStatus

      // mapa de reglas para status
      const statusMap = {
        [lineStatus.ISSUE]: { icon: 'exclamation-triangle', color: 'text-yellow' },
        [lineStatus.ISSUE_WITHOUT_LOCK]: { icon: 'exclamation-triangle', color: 'text-orange' },
        [lineStatus.ISSUE_LOCK_TASK]: { icon: 'exclamation-triangle', color: 'text-red' },
        [lineStatus.ISSUE_LOCK_ACTIVITY]: { icon: 'hand', color: 'text-orange' },
        [lineStatus.ISSUE_LOCK_ACTIVITY_PARENT]: { icon: 'hand', color: 'text-orange' },
        [lineStatus.ISSUE_LOCK_PROJECT]: { icon: 'hand', color: 'text-red' }
      }

      // buscar directamente en el assignment
      return statusMap[assignment.issue_status] || null
    },

    withSubTasks() {
      // retornamos true si depth es menor a 5 por que admite hasta 5 niveles de subtareas
      return this.deph < 4 && this.company && this.company.configs && this.company.configs.subtasks;
    },

    withLockTypeCreator(task) {
      // busamos en task.lines si existe una linea con status 20 (lock type creator)
      if (this.project.can_task_resolutor && this.company && this.company.configs && this.company.configs.subtasks) {
        // si existe una linea con status 20 si encuentra la menos una linea con status 20 retornamos true caso contrario false
        return task.lines && task.lines.some(line => line.status === this.lineStatus.ISSUE);
      } else {
        return false;
      }
    },

    onCreateTaskSubTask(task) {
      this.$refs.task_modal.show(task);
    },

    displayHistory(id) {
      // si abre historial, cierra subtareas de esa fila
      const row = this.listTasks.find((task) => task.id === id);
      if (row && this.isTaskExpanded(row)) {
        this.collapseTaskBranch(row);
      }

      if (this.openHistoryTaskIds[id]) {
        this.$delete(this.openHistoryTaskIds, id);
      } else {
        this.$set(this.openHistoryTaskIds, id, true);
      }
    },
    hasPendingValidation(row) {
      if (!row.lines || !row.lines.length) return false;
      return row.lines.some(line => line.status === 1);
    },
    hasPendingValidationIssue(row) {
      if (!row.lines || !row.lines.length) return false;
      return row.lines.some(line => line.status == this.lineStatus.ISSUE_PENDIG);
    },
    canEditAssignments() {
      return this.canAdd;
    },

    reload() {
      // No colapsar niveles: el padre hace refresh silencioso y rehidrata expandedTaskIds.
      this.$emit('reload');
    },

    showPreview(document) {
      this.document = document;
      this.$refs.previewModal.show(this.document);
      if (this.document.exif) {
        EventBus.$emit("load-locations", this.document.exif);
      }
    },

    onClickTaskEdit(task) {
      this.$refs.task_update_modal.show(task);
    },

    onCommentChanged(assignment) {
      this.$refs.assignment_comment_task_modal.show(assignment.id);
    },

    onClickValidate(assignment, assignmentLine = null) {
        this.$refs.assignment_validate_quantity_modal.show(assignment.id, assignmentLine);
      },
    onClickValidateIssue(assignment) {
        this.$refs.assignment_validate_issue_task_modal.show(assignment.id);
      },
    onEditLine(assignmentLine, assignment) {
      this.$refs.assignment_line_edit_modal.show(assignmentLine, assignment);
    },
    onDeleteLine(assignmentLine, assignmentId) {
      this.$dialog.confirm({
        title: this.$t("delete"),
        message: this.$t("delete_assignment_line_confirm"),
        type: "is-danger",
        hasIcon: true,
        iconPack: "fas",
        icon: "trash-alt",
        confirmText: this.$t("delete"),
        cancelText: this.$t("cancel"),
        onConfirm: async () => {
          try {
            let url = "/api/v2/assignment/" + assignmentId + "/line/" + assignmentLine.id;
            const { data } = await axios.delete(url);

            if (data && data.success) {
              this.$toast.open({
                message: this.$t("success_deleting_generic"),
                type: "is-success",
                position: "is-top-right"
              });
              
            } else {
              this.$toast.open({
                message: data.msg || this.$t("error_deleting_generic"),
                type: "is-danger",
                position: "is-top-right"
              });
            }
            
            this.$emit("reload");
            EventBus.$emit("refreshActivityDocumentsNotifications", true);
          } catch (error) {
            this.$toast.open({
              message: this.$t("remove_error"),
              type: "is-danger",
              position: "is-top-right"
            });
          }

        },
      });
    },
  },
  watch: {
    
  }
};
</script>